export default {
  init(authBase) {
    const requestCall = authBase;
    return {
      fetchAccountData(requestPayload) {
        return requestCall.accountData(requestPayload);
      },
      postActivityData(requestPayload) {
        return requestCall.submitRecommendForm(requestPayload);
      },
    };
  },
};
